export enum DayFrequency {
  ONCE = "ONCE",
  TWICE = "TWICE",
  THRICE = "THRICE",
  FOUR_TIMES = "FOUR_TIMES",
}

// Fixed default dosage times — morning/afternoon/evening/night. Every slot
// after the first defaults to one of these (morning/09:00 AM is the first
// slot's own default — see DEFAULT_TIME_12HR in constants.ts) regardless of
// what the first dose time is. Callers only use these to fill in a BLANK
// slot (see the "only set if not already set" guards in medication/index.tsx
// and vitals/index.tsx) — once a slot has a value, editing another slot
// (including the first) never touches it. That's a deliberate simplification:
// no more "reflow the rest of the day around whatever I just typed" — each
// time card is independent once populated.
const AFTERNOON = "01:00 PM";
const EVENING = "05:00 PM";
const NIGHT = "09:00 PM";

/**
 * Returns the fixed default dosage times for the remaining slots of a given
 * daily frequency (the first slot/firstDosage is set separately and isn't
 * part of this — see paintDosageInput callers).
 * @param dayFrequency Frequency of dosage per day
 * @returns Object containing default dosage times as strings in 'hh:mm a' format (12-hour format with AM/PM)
 */
export const calculateOptimalDosages = (
  dayFrequency: DayFrequency
): {
  secondDosage?: string;
  thirdDosage?: string;
  fourthDosage?: string;
} => {
  switch (dayFrequency) {
    case DayFrequency.TWICE:
      return { secondDosage: NIGHT };
    case DayFrequency.THRICE:
      return { secondDosage: AFTERNOON, thirdDosage: NIGHT };
    case DayFrequency.FOUR_TIMES:
      return {
        secondDosage: AFTERNOON,
        thirdDosage: EVENING,
        fourthDosage: NIGHT,
      };
    default:
      return {};
  }
};
